import { ideaRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const ideaRoute: RouteObject[] = [
  {
    path: ideaRoutePaths.ideas.path,
    async lazy() {
      const IdeaListPage = await import('@/pages/idea/idea-list-page');
      return { Component: IdeaListPage.default };
    },
  },
  {
    path: ideaRoutePaths.ideaWrite.path,
    async lazy() {
      const IdeaWritePage = await import('@/pages/idea/idea-write-page');
      return { Component: IdeaWritePage.default };
    },
  },
  {
    path: ideaRoutePaths.ideaDetail.path,
    async lazy() {
      const IdeaDetailPage = await import('@/pages/idea/idea-detail-page');
      return { Component: IdeaDetailPage.default };
    },
  },
  {
    path: ideaRoutePaths.feeds.path,
    async lazy() {
      const FeedListPage = await import('@/pages/idea/feed-list-page');
      return { Component: FeedListPage.default };
    },
  },
  {
    path: ideaRoutePaths.feedWrite.path,
    async lazy() {
      const FeedWritePage = await import('@/pages/idea/feed-write-page');
      return { Component: FeedWritePage.default };
    },
  },
  {
    path: ideaRoutePaths.feedDetail.path,
    async lazy() {
      const FeedDetailPage = await import('@/pages/idea/feed-detail-page');
      return { Component: FeedDetailPage.default };
    },
  },
];
